import React, { useState } from "react";

export function UserSection({ userName, onSaveName, onChangeName }) {
  const [nameInput, setNameInput] = useState("");

  const handleSave = () => {
    if (!nameInput.trim()) return;
    onSaveName(nameInput.trim());
    setNameInput("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSave();
  };

  if (!userName) {
    return (
      <div className="user-bar" style={{ background: "#ffffff", borderColor: "var(--accent)" }}>
        <div className="user-bar-info" style={{ flex: 1, gap: "12px" }}>
          <i className="ti ti-user-circle" style={{ fontSize: "20px", color: "var(--accent)" }}></i>
          <input
            type="text"
            placeholder="Escribí tu nombre para registrar avances..."
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{ 
              flex: 1, 
              border: "none", 
              padding: "6px 0",
              background: "transparent",
              fontSize: "13.5px",
              boxShadow: "none"
            }}
          />
        </div>
        <button onClick={handleSave} className="btn-accent" style={{ padding: "6px 12px", fontSize: "12.5px" }}>
          Registrar
        </button>
      </div>
    );
  }

  return (
    <div className="user-bar">
      <div className="user-bar-info">
        <i className="ti ti-user-check" style={{ fontSize: "16px", color: "var(--accent)" }}></i>
        <span>
          Identificado como: <strong>{userName}</strong>
        </span>
      </div>
      <button className="user-bar-btn-change" onClick={onChangeName}>
        Cambiar usuario
      </button>
    </div>
  );
}
